import { defaultSpring } from 'shared/kanimate';
import { iconDanger } from 'globals/assets';
import { chatMessageTimestamp } from 'globals/colors';

export const staticStyles = {
  message: {
    marginTop: '10px',
  },
  failed: {
    background: `url('${iconDanger}')`,
    backgroundSize: 16,
    backgroundRepeat: 'no-repeat',
    height: 16,
    width: 16,
    marginTop: 10,
    marginLeft: 8,
    cursor: 'pointer',
  },
  userDate: {
    alignSelf: 'flex-start',
    color: chatMessageTimestamp,
    fontSize: '11px',
    marginTop: '10px',
  },
  customerDate: {
    alignSelf: 'flex-end',
    color: chatMessageTimestamp,
    fontSize: '11px',
    marginTop: '10px',
  },
};

export const start = () => {
  return {
    marginTop: 100,
    opacity: 0.4,
  };
};

export const end = ownProps => {
  if (ownProps.short) {
    return {
      marginTop: defaultSpring(10),
      opacity: defaultSpring(1),
    };
  }

  return {
    marginTop: defaultSpring(32),
    opacity: defaultSpring(1),
  };
};

export const tween = values => {
  return {
    message: {
      marginTop: `${values.marginTop}px`,
      opacity: values.opacity,
    },
  };
};
